import type { TradeSelectorVariant } from "@simplybusiness/mobius-trade-selector";
import type { QuestionComponentProps } from "../../types";
import { TradeQuestion as DefaultTradeQuestion } from "./TradeQuestion";
import { AiTradeQuestion } from "./AiTradeQuestion";
import { ExperimentTradeQuestion } from "./ExperimentTradeQuestion";
import { useExperiment } from "../../../../../../../hooks/experiments";

export const TradeQuestion = (props: QuestionComponentProps) => {
  const { type } = props;

  const experimentVariant = useExperiment("uk2602BusinessTradeSelector");

  const variant: TradeSelectorVariant =
    type === "trade_search_ai" ? "ai" : "default";

  if (variant === "ai") {
    return <AiTradeQuestion {...props} />;
  }
  if (experimentVariant) {
    return <ExperimentTradeQuestion {...props} />;
  } else {
    return <DefaultTradeQuestion {...props} />;
  }
};
